var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    viewBox: "0 0 25 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0938 9.54102C11.8008 9.54102 11.5176 9.42383 11.2148 9.15039L1.40039 0.449219C1.9375 0.146484 2.5332 0 3.31445 0H20.8633C21.6445 0 22.2402 0.146484 22.7773 0.449219L12.9629 9.15039C12.6602 9.42383 12.377 9.54102 12.0938 9.54102ZM0.248047 15.5371C0.101562 15.1465 0.00390625 14.6875 0.00390625 14.082V3.28125C0.00390625 2.62695 0.111328 2.10938 0.238281 1.82617L7.51367 8.28125L0.248047 15.5371ZM23.9297 15.5371L16.6641 8.28125L23.9395 1.82617C24.0664 2.10938 24.1738 2.62695 24.1738 3.28125V14.082C24.1738 14.6875 24.0859 15.1465 23.9297 15.5371ZM3.09961 17.3633C2.38672 17.3633 1.81055 17.207 1.40039 16.9531L8.88086 9.48242L10.1504 10.6055C10.7754 11.1719 11.4004 11.4355 12.0938 11.4355C12.7773 11.4355 13.4023 11.1719 14.0371 10.6055L15.2969 9.48242L22.7773 16.9531C22.3672 17.207 21.791 17.3633 21.0781 17.3633H3.09961Z",
    fill: "#FF9500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.30674cc599f7d08c7d63810fdf47ee05.svg";
export { ForwardRef as ReactComponent };